/**
 * Core (gateway/orchestration) event types for real-time notifications and durable event recording.
 */
export enum CoreEventType {
  ORCHESTRATION_STARTED = 'core:orchestration-started',
  ORCHESTRATION_COMPLETED = 'core:orchestration-completed',
  ORCHESTRATION_FAILED = 'core:orchestration-failed',
  SHARING_CREATED = 'core:sharing-created',
  JOBS_UPDATED = 'jobs:updated',
  FEATURE_FLAG_TOGGLED = 'core:feature-flag-toggled',
}

/**
 * Pub/sub channel for core events.
 */
export const CORE_EVENTS_CHANNEL = 'core:events';